<template>
  <header class="admin-data-header">
    <app-admin-data-report-modal />
  </header>
</template>

<script>

    import AppAdminDataReportModal from '@views/admin/data/components/report/AdminDataReportModal'

    export default {
        components: {
          AppAdminDataReportModal
        },

        data() {
            return {

            }
        },

        mixins: [],

        mounted() {
          
        },

        beforeDestroy() {
       
        }
    }
</script>

<style lang="scss" scoped>
.admin-data-header {
  display: flex;
  align-items: center;
}
</style>
